import { useExport } from './useExport'
import {
  createManagerExport,
  getManagerExport,
  type ManagerExportRequest,
} from '@/api/managerSubmissions'

export function useExportManagerSubmissions() {
  const exportHook = useExport<ManagerExportRequest>({
    createExportFn: createManagerExport,
    getExportFn: getManagerExport,
    filenamePrefix: 'manager-submissions',
  })

  return {
    ...exportHook,
    exportSubmissions: exportHook.startExport,
  }
}
